import React from "react";
import { useMenuRowProps } from "./menuRows";

interface DropdownMenuItemProps {
  onClick: () => void;
  isSelected?: boolean;
  children: React.ReactNode;
  /** Extra classes appended last — e.g. to override the default `px-2`. */
  className?: string;
  /** Keeps its place in the list but does nothing. */
  disabled?: boolean;
  /** Muted trailing reason, for when disabling alone does not explain itself —
   *  a cause outside the list, like "view only". A rule the list already shows
   *  (a type it already has) needs no words. */
  hint?: string;
}

export function DropdownMenuItem({
  onClick,
  isSelected,
  children,
  className = "",
  disabled = false,
  hint,
}: DropdownMenuItemProps) {
  const rowProps = useMenuRowProps();
  return (
    <button
      type="button"
      {...rowProps}
      onClick={disabled ? undefined : onClick}
      aria-disabled={disabled || undefined}
      className={`w-full flex items-center justify-between item-height px-2 gap-2 transition-colors ${
        disabled
          ? "cursor-default text-fg-muted"
          : isSelected
            ? "bg-accent/10 cursor-pointer"
            : `${rowProps.role ? "focus:bg-list-hover" : "hover:bg-list-hover"} cursor-pointer`
      } ${className}`}
    >
      {children}
      {hint && <span className="text-fg-muted-medium-xs">{hint}</span>}
    </button>
  );
}
